var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-tab',{attrs:{"tabs":_vm.tabsData},on:{"tab-click":_vm.tabSelected}}),_c('keep-alive',[_c(_vm.orderComponent,{ref:"listMethod",tag:"component",attrs:{"param":_vm.param},on:{"order-view":_vm.orderView}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }